import toast from 'react-hot-toast';
import { useModalStore } from '../store/modal';

class MessageHandlerService {
  private modalStore: typeof useModalStore;

  constructor() {
    this.modalStore = useModalStore;
  }

  success(message: string) {
    toast.success(message, {
      duration: 3000,
    });
  }

  error(error: any) {
    let errorMessage = 'Ocorreu um erro inesperado.';

    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error?.error) {
      // Direct error message from backend
      errorMessage = error.error;
    } else if (error?.response?.data?.error) {
      // Error from axios response
      errorMessage = error.response.data.error;
    } else {
      const data = error?.response?.data || error;

      if (data?.message) {
        errorMessage = data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      // Handle validation errors array if present
      const details = data?.details || data?.response?.data?.details;
      if (details && Array.isArray(details)) {
        errorMessage = details
          .map((detail: { field: string; message: string }) => detail.message)
          .join('\n');
      }
    }

    toast.error(errorMessage, {
      duration: 5000,
    });
  }

  warning(message: string) {
    toast(message, {
      icon: '⚠️',
      duration: 4000,
      style: {
        background: '#fff7ed',
        color: '#9a3412',
        border: '1px solid #fed7aa',
      },
    });
  }

  info(message: string) {
    toast(message, {
      icon: 'ℹ️',
      duration: 3000,
      style: {
        background: '#f0f9ff',
        color: '#075985',
        border: '1px solid #bae6fd',
      },
    });
  }

  confirm(title: string, message: string, onConfirm: () => void, onCancel?: () => void) {
    this.modalStore.getState().openModal('confirm', {
      title,
      message,
      onConfirm: () => {
        onConfirm();
        // Close the confirmation modal after executing the confirm action
        this.modalStore.getState().closeModal();
      },
      onCancel: () => {
        if (onCancel) {
          onCancel();
        }
        // Close the confirmation modal after executing the cancel action
        this.modalStore.getState().closeModal();
      },
      variant: 'warning',
    });
  }
}

export const messageHandler = new MessageHandlerService();
